/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum TemplateParameterTypeEnum {
  BOOLEAN = "BOOLEAN",
  NUMBER = "NUMBER",
  TEXT = "TEXT",
}

export interface ExperimentalCreateAutomationRuleFromTemplateParameter {
  name: string;
  type: TemplateParameterTypeEnum;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: experimentalCreateAutomationRuleFromTemplateMutation
// ====================================================

export interface experimentalCreateAutomationRuleFromTemplateMutation_experimentalCreateAutomationRuleFromTemplate {
  ruleId: string | null;
  ruleUuid: string | null;
}

export interface experimentalCreateAutomationRuleFromTemplateMutation {
  experimentalCreateAutomationRuleFromTemplate: experimentalCreateAutomationRuleFromTemplateMutation_experimentalCreateAutomationRuleFromTemplate | null;
}

export interface experimentalCreateAutomationRuleFromTemplateMutationVariables {
  templateId: string;
  cloudId: string;
  automationStack: string;
  spaceId?: string | null;
  parameters?: ExperimentalCreateAutomationRuleFromTemplateParameter[] | null;
}
